<ng-template #modalError>
  <lib-sura-modal
    (handleSubmit)="onSubmit()"
    [disableClose]="true"
    class="modal-error"
  >
    <ng-container slot="body">
      <div class="col p-3">
        <div class="text-center header">
          <div class="col-12 pb-3">
            <i class="far fa-exclamation-circle fa-4x d-block header__icon"></i>
            <span class="header__title">Lo sentimos,</span>
          </div>
        </div>
        <div class="text-center">
          <p class="error-descripcion">
            {{ error.description }}
          </p>
        </div>
        <div class="w-100 pt-2 d-flex justify-content-center">
          <button
            type="button"
            (click)="onSubmit()"
            id="btn-error-modal"
            class="button"
          >
            {{ error.buttonText }}
          </button>
        </div>
      </div>
    </ng-container>
  </lib-sura-modal>
</ng-template>
